import api from "./api";

export const listTemplates = () => api.get("/checklist-templates");
export const getTemplate = (id) => api.get(`/checklist-templates/${id}`);
export const createTemplate = (payload) => api.post("/checklist-templates", payload);
export const updateTemplate = (id, payload) => api.put(`/checklist-templates/${id}`, payload);
export const deleteTemplate = (id) => api.delete(`/checklist-templates/${id}`);
